import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseProjectsTargetedToCompletePayload } from '../payloads/projectsTargetedToCompletePayload';
import {
  InsightChartFactory,
  InsightChartFactoryProps,
} from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';

export const buildProjectsTargetedToCompleteInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload = parseProjectsTargetedToCompletePayload(payload);
  const { projects_targeted_to_complete } =
    parsedPayload.data.attributes.aggregate;

  return (props: InsightChartFactoryProps) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.KPI)
      .setProps({
        chartData: {
          value: projects_targeted_to_complete.current ?? 0,
          trend: projects_targeted_to_complete.percentage_change ?? 0,
          trendIsPercent: true,
          description: props.name,
        },
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
